function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#FFF",
  d: "M124.233 75.098l5.375-30.59-13.28-6.877h-13.281v14.23z"
}), React.createElement("path", {
  fill: "#FFF",
  stroke: "#0096D6",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.846,
  d: "M127.79 54.064l-8.269 53.29H27.037c-2.901 0-5.254-2.364-5.254-5.282l4.579-28.074 3.25-19.934 2.68-16.433h72.652"
}), React.createElement("path", {
  stroke: "#0096D6",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.846,
  d: "M32.85 39.766l43.386 37.707 37.404-26.087"
}), React.createElement("path", {
  stroke: "#0096D6",
  strokeLinecap: "round",
  strokeWidth: 2.846,
  d: "M4.708 70.358H26.05M.439 51.86h29.09M10.4 90.28h13.438"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M122.968 3.718l-10.435 21.819c-4.427 8.22-4.11 15.177.949 20.869s12.015 5.692 20.87 0c4.426-6.957 5.375-12.648 2.845-17.075s-7.273-12.964-14.23-25.613z"
}), React.createElement("path", {
  fill: "#0096D6",
  d: "M123.533.635c-1.314 0-2.244.896-2.646 1.938-3.225 8.43-6.4 15.268-11.507 24.425-6.43 11.539 1.95 24.862 14.153 24.862 12.172 0 20.564-13.323 14.126-24.862-5.093-9.157-8.272-15.995-11.493-24.425-.394-1.042-1.32-1.938-2.633-1.938m-.004 4.012c3.236 8.357 6.455 15.144 11.323 23.893 2.472 4.434 2.448 9.406-.069 13.644-2.414 4.065-6.619 6.491-11.25 6.491-4.642 0-8.856-2.426-11.272-6.492-2.517-4.235-2.544-9.208-.074-13.643 4.849-8.69 8.07-15.47 11.342-23.893"
}), React.createElement("path", {
  fill: "#0096D6",
  d: "M125.59 27.411c.255-.946.477-1.12.684-1.158.21-.031.475.056.955.877 1.991 3.268 3.3 6.059 4 8.732.537 1.972-.81 4.23-2.903 4.57-2.206.352-4.023-1.391-4.085-3.437-.078-2.768.377-5.87 1.35-9.584"
}));

var SvgInstantInkIcon = function SvgInstantInkIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 141,
    height: 108,
    viewBox: "0 0 141 108",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInstantInkIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/instant-ink-icon.f3ff2fc5.svg";
export { ForwardRef as ReactComponent };